module.exports = __webpack_public_path__ + "img/section-header-mobile.db428d82.svg";